module.exports = __webpack_public_path__ + "img/about-section-certification-process-551-compressed.2f248c2e.jpg";